/**
 * The client's Master Sheet headings - MOLD LIST_63, confirmed on 24 Oct 2026
 * as the one format for the Excel export, the import and the catalog on screen.
 *
 * Verbatim, in the sheet's order. Do not "improve" them ("NO.OF", "MESHANISM"):
 * they are the client's words, and the point is that the website, the file
 * MouldTrack writes and the file the client fills in all say the same thing.
 * test/format-suite.mts checks this list against the client's own file.
 */
export const MASTER_SHEET_COLUMNS = [
  ['sno', 'S.NO'],
  ['owner', 'Mould Ownership'],
  ['customer', 'Customer'],
  ['image', 'IMAGE'],
  ['codeAndName', 'CODE AND NAME'],
  ['moldNumber', 'MOLD NUMBER'],
  ['moldName', 'MOLD NAME'],
  ['toolType', 'TOOL TYPE'],
  ['cavities', 'NO.OF CAVITIES'],
  ['runnerType', 'RUNNER TYPE'],
  ['material', 'MATERIAL-SHRINKAGE'],
  ['gateType', 'GATE TYPE'],
  ['ejectionType', 'EJECTION TYPE'],
  ['mechanism', 'NO.OF SLIDERS AND LIFTERS AND ITS MESHANISM'],
  ['coreCavityMaterial', 'CORE CAVITY MATERIAL'],
  ['moldBaseMaterial', 'MOLD BASE MATERIAL'],
  ['moldSize', 'MOLD SIZE (LxBxH)'],
  ['designer', 'DESIGNER NAME'],
  ['manufactureYear', 'MANUFACTURE/TRANSFERRED YEAR'],
  ['manufacturer', 'MANUFACTURER'],
  ['toolTransfer', 'TOOL TRANSFER'],
  ['remarks', 'REMARKS'],
  ['qrNumber', 'QR NUMBER'],
  ['location', 'Location'],
] as const;

export type MasterSheetColumn = (typeof MASTER_SHEET_COLUMNS)[number][0];

/** Each heading by name: `MASTER_SHEET.moldSize` is "MOLD SIZE (LxBxH)". */
export const MASTER_SHEET = Object.fromEntries(MASTER_SHEET_COLUMNS) as Record<MasterSheetColumn, string>;

/** The 24 headings in the sheet's order. */
export const MASTER_SHEET_HEADINGS: string[] = MASTER_SHEET_COLUMNS.map(([, heading]) => heading);
